<template>
  <div class="completion pt-5">
    <b-form class="completion-form">
      <div class="form-group flex-inline-form-md">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input
            type="text"
            placeholder="Search shipment by shipment number"
            @input="onChangeSearchQuery($event)"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group class="company__multiselect" style="min-width: 225px;">
          <base-multiselect
            :loading="companySelectorLoading"
            :internalSearch="false"
            :options="companyList"
            :searchable="true"
            :label="'name'"
            :track-by="'id'"
            :placeholder="'Type for search'"
            :initSelect="selectedCompany"
            @open="onDropdown"
            @search-change="findCompany"
            @input-value="onSelectCompany($event)"
            ></base-multiselect>
        </b-input-group>
        <b-input-group>
          <b-form-select
            v-model="sortType"
            @change="onChangeSortType($event)"
            :options="sortOptions"></b-form-select>
        </b-input-group>
      </div>
    </b-form>
    <Item :summaries="summaries" v-if="loaded" />
    <nav aria-label="Shipment pagination" class="pull-right">
      <ul class="pagination">
        <li class="page-item" :class="{disabled: prevDisabled}">
          <a class="page-link" href="#" @click.prevent="prevPage()"><span aria-hidden="true">&laquo;</span> Previous</a>
        </li>
        <li class="page-item" :class="{disabled: nextDisabled}">
          <a class="page-link" href="#" @click.prevent="nextPage()">Next <span aria-hidden="true">&raquo;</span></a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import BaseMultiselect from '@/components/BaseMultiselect';

import { throttle, last, debounce, isString, isEmpty, omit } from 'lodash';
import Item from './Item';

export default {
  name: 'completion',
  components: {
    Item,
    Multiselect,
    BaseMultiselect,
  },
  data() {
    return {
      recursive: '',
      summaries: [],
      loaded: false,
      transform: 0,
      shipment: [
        {
          numBar: 1,
          widthBar: 0,
        },
      ],
      searchQuery: '',
      sortOptions: [
        { value: null, text: '== Sort by ==', disabled: true },
        { value: 'NUMBER.ASC', text: 'Number 0-9' },
        { value: 'NUMBER.DESC', text: 'Number 9-0' },
        { value: 'CREATED_AT.DESC', text: 'Last Created' },
        { value: 'CREATED_AT.ASC', text: 'Oldest Created' },
      ],
      sortType: null,
      lastData: null,
      lastDataAr: [],
      companyList: [],
      selectedCompany: null,
      companySelectorLoading: false,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'completions', name: 'Completions' },
    ]);
    this.$store.commit('shipment_md/shipments/CLEAR_QUERY');
    this.$store.commit('companies/CLEAR_QUERY');
    this.$store.commit('companies/SET_QUERY_COUNT', 1e6);
    this.$store.dispatch('shipment_md/shipments/LOAD_DATA_COMPLETION').then(() => {
      this.$store.dispatch('shipment_md/shipments/LOAD_SUMMARY').then((summary) => {
        this.summaries = summary;
        this.loaded = true;
        this.recursiveLoadProgress();
      });
    });
    this.initLoadCompany().then(() => {
      this.initFromUrl();
    });
  },
  beforeDestroy() {
    clearTimeout(this.recursive);
  },
  computed: {
    shipments() {
      return this.$store.getters['shipment_md/shipments/shipments'];
    },
    companies() {
      return this.$store.getters['companies/companies'];
      // .filter(c => c.type === 'DEFAULT');
      // TODO: filter company type default and partner type full
    },
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.shipments.length < 10;
    },
  },
  methods: {
    initFromUrl() {
      const { query } = this.$route;

      if (isString(query.company_id) && query.company_id !== undefined) {
        this.onSelectCompany({ value: query.company_id }, true);
      }
      if (query.sort !== undefined) {
        this.onChangeSortType(query.sort, true);
      }
      if (query.q !== undefined) {
        this.onChangeSearchQuery(query.q, true);
      }

      this.loadData();
      this.$store.dispatch('shipment_md/shipments/LOAD_INFO');
    },
    resetPagination() {
      this.lastData = null;
      this.lastDataAr = [];
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.resetPagination();
      context.$store.commit('shipment_md/shipments/SET_QUERY_SEARCH', searchQuery);
      context.loadData();
    }, 500, {
      leading: false,
    }),
    loadData() {
      this.$store.commit('shipment_md/shipments/SET_QUERY_LAST_DATA', this.lastData);
      if (this.searchQuery.trim() !== '') {
        return this.$store.dispatch('shipment_md/shipments/FIND_DATA_COMPLETION').then(() => {
          this.loaded = false;

          this.$store.dispatch('shipment_md/shipments/FIND_DATA_SUMMARY').then((summary) => {
            this.summaries = summary;
            this.loaded = true;
            this.recursiveLoadProgress('FIND_DATA_SUMMARY');
          });
        });
      }
      return this.$store.dispatch('shipment_md/shipments/LOAD_DATA_COMPLETION').then(() => {
        this.loaded = false;

        this.$store.dispatch('shipment_md/shipments/LOAD_SUMMARY').then((summary) => {
          this.summaries = summary;
          this.loaded = true;
        });
      });
    },
    prevPage() {
      this.lastDataAr.pop();
      if (this.lastDataAr.length) {
        this.lastData = last(this.lastDataAr);
      } else {
        this.lastData = null;
      }
      this.loadData();
    },
    nextPage() {
      const shipment = last(this.shipments);
      const data = shipment.number;

      this.lastDataAr.push(data);
      this.lastData = data;
      this.loadData();
    },
    recursiveLoadProgress(prefix = 'LOAD_SUMMARY') {
      clearTimeout(this.recursive);
      this.recursive = setTimeout(() => {
        this.$store.dispatch(`shipment_md/shipments/${prefix}`).then((shipments) => {
          this.summaries = shipments;
          this.recursiveLoadProgress(prefix);
        });
      }, 15e3);
    },
    findCompany: debounce(function findCompany(query) {
      const payload = { value: query.trim() };
      this.companySelectorLoading = true;

      return this.$store.dispatch('companies/FREE_SEARCH_DATA', payload).then(({ data }) => {
        const { companies } = data;
        if (query.trim() === '') {
          this.companyList = companies.filter((c, index) => index <= 4);
        } else {
          this.companyList = companies;
        }
        this.companySelectorLoading = false;
        this.companyLoaded = companies;
      });
    }, 5e2),
    initLoadCompany() {
      return this.$store.dispatch('companies/FREE_SEARCH_DATA', { value: '' }).then(({ data }) => {
        const { companies } = data;
        this.companyList = companies;
      });
    },
    onSelectCompany({ value: newValue }, fromInit = false) {
      this.$store.commit('shipment_md/shipments/SET_COMPANY_ID', newValue);
      if (newValue !== null) {
        this.$router.push({
          query: {
            ...this.$route.query,
            company_id: fromInit ? newValue : newValue.id,
          },
        });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['company_id']) } });
      }

      if (!fromInit) {
        const companyId = newValue === null ? null : newValue.id;
        this.$store.commit('shipment_md/shipments/SET_COMPANY_ID', companyId);
        this.loadData();
        this.$store.dispatch('shipment_md/shipments/LOAD_INFO');
      } else {
        this.selectedCompany = newValue;
      }
    },
    onDropdown() {
      if (this.companyList.length > 0) return false;
      return this.$store.dispatch('companies/FREE_SEARCH_DATA', { value: '' }).then(({ data }) => {
        const { companies } = data;
        this.companyList = companies.filter((c, index) => index <= 4);
      });
    },
    onChangeSortType(newValue, fromInit = false) {
      this.$router.push({ query: { ...this.$route.query, sort: newValue } });
      this.$store.commit('shipment_md/shipments/SET_QUERY_SORT', newValue);
      this.sortType = newValue;

      if (!fromInit) {
        this.loadData();
      }
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('shipment_md/shipments/SET_QUERY_SEARCH', newValue);
      if (!isEmpty(newValue)) {
        this.$router.push({ query: { ...this.$route.query, q: newValue } });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['q']) } });
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
  },
};
</script>
<style lang="sass">
@import "~vue-multiselect/dist/vue-multiselect.min"

.multiselect
  z-index: 10

.list-group--full
  margin: -9px

@media screen and (max-width: 768px)
  .company__multiselect
    min-width: 0px !important

.completion-form
  .multiselect--active
    .multiselect__content-wrapper
      display: block !important
      z-index: 10
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/completion/Index.vue